'use client';

import { PlusIcon } from 'lucide-react';

import CreateCustomerSheet from '@/app/(app)/customers/create-sheet';
import { CustomersTableProvider, useCustomersTableCtx } from '@/app/(app)/customers/table/provider';
import { CustomerTable } from '@/app/(app)/customers/table/table';
import { PageMain } from '@/app/(app)/page-main';
import { PaginationWithIcons } from '@/components/pagination';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';

export default function CustomersPage() {
  return (
    <CustomersTableProvider>
      <PageMain
        title='Customers'
        right={
          <CreateCustomerSheet>
            <Button size='sm'>
              <PlusIcon className='size-4' />
              New Customer
            </Button>
          </CreateCustomerSheet>
        }
      >
        <Content />
      </PageMain>
    </CustomersTableProvider>
  );
}

function Content() {
  const { ids, filters, isLoading, total, pages, selectedIds, setFilters } = useCustomersTableCtx();

  if (ids.length === 0) {
    if (isLoading) {
      return <Skeleton className='h-[80dvh] w-full' />;
    }
  }

  return (
    <div className='space-y-2'>
      <CustomerTable />
      <div className='mt-4 flex w-full items-center justify-between px-2'>
        <div className='text-muted-foreground'>
          Total: {total.toLocaleString()} customers{selectedIds.length > 0 && `, ${selectedIds.length} selected`}
        </div>
        <PaginationWithIcons
          currentPage={filters.page}
          totalPages={pages}
          onPageChange={(page) => setFilters({ ...filters, page })}
        />
      </div>
    </div>
  );
}
